export interface StatItem {
  name: string;
  value: string;
}

export default function StatsGrid({ stats }: { stats: StatItem[] }) {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700">
      <div className="grid grid-cols-1 gap-px bg-gray-900/5 dark:bg-gray-700/50 sm:grid-cols-2 lg:grid-cols-4 rounded-xl overflow-hidden">
        {stats.map((stat) => (
          <div
            key={stat.name}
            className="bg-white dark:bg-gray-800 px-4 py-6 sm:px-6 lg:px-8"
          >
            <p className="text-sm/6 font-medium text-gray-500 dark:text-gray-400">
              {stat.name}
            </p>
            <p className="mt-2 flex items-baseline gap-x-2">
              <span className="text-4xl font-semibold tracking-tight text-gray-900 dark:text-white">
                {stat.value}
              </span>
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
